<div nz-col class="bg-white px-4 rounded-xl shadow-sm">
  <div nz-col>
    <div
      nz-row
      [nzGutter]="[10, 10]"
      style="padding: 10px"
      nzJustify="space-between"
    >
      <div nz-col nzFlex="auto">
        <form nz-form [formGroup]="searchForm" class="ant-advanced-search-form">
          <!-- Filter controls reflow 6 → 4 → 3 → 2 → 1 per row across breakpoints
               so nothing clips on narrower viewports; every control fills its
               column for a consistent width. -->
          <div nz-row [nzGutter]="[12, 12]">
            <div
              nz-col
              [nzXl]="4"
              [nzLg]="6"
              [nzMd]="8"
              [nzSm]="12"
              [nzXs]="24"
            >
              <nz-range-picker
                [nzRanges]="ranges"
                [(ngModel)]="date"
                [ngModelOptions]="{ standalone: true }"
                class="w-full"
                [nzFormat]="dateFormat"
                [nzPlaceHolder]="[
                  'statistic.operation.search.start' | translate,
                  'statistic.operation.search.finish' | translate
                ]"
                (ngModelChange)="changeCalendar($event)"
              ></nz-range-picker>
            </div>
            <div
              nz-col
              [nzXl]="4"
              [nzLg]="6"
              [nzMd]="8"
              [nzSm]="12"
              [nzXs]="24"
            >
              <beautyapp-input
                placeholder="{{
                  'statistic.operation.search.operationNumber' | translate
                }}"
                formControlName="operationId"
              ></beautyapp-input>
            </div>
            <div
              nz-col
              [nzXl]="4"
              [nzLg]="6"
              [nzMd]="8"
              [nzSm]="12"
              [nzXs]="24"
            >
              <beautyapp-select
                placeholder="{{ 'calendar.form.paymentMethod' | translate }}"
                formControlName="paymentType"
                [data]="paymentTypes"
                valueMember="id"
                displayMember="name"
              ></beautyapp-select>
            </div>
            <div
              nz-col
              [nzXl]="4"
              [nzLg]="6"
              [nzMd]="8"
              [nzSm]="12"
              [nzXs]="24"
            >
              <!-- beaut-542. Multi-select: the operator comparing, say, salaries
                   against expenses had to run the screen twice and add the two
                   totals by hand. Chosen sources are OR'd; choosing none still
                   means all of them. -->
              <beautyapp-select
                placeholder="{{
                  'statistic.operation.search.sourceOperation' | translate
                }}"
                formControlName="operationSource"
                data-test="operation-source-filter"
                mode="multiple"
                [nzMaxTagCount]="1"
                [data]="operationSource"
                valueMember="id"
                displayMember="name"
              ></beautyapp-select>
            </div>
            <div
              nz-col
              [nzXl]="4"
              [nzLg]="6"
              [nzMd]="8"
              [nzSm]="12"
              [nzXs]="24"
            >
              <beautyapp-select
                placeholder="{{
                  'statistic.operation.search.bank' | translate
                }}"
                formControlName="bankId"
                [data]="banks"
                valueMember="id"
                displayMember="name"
                mode="multiple"
              ></beautyapp-select>
            </div>
            <div nz-col [nzSpan]="4">
              <beautyapp-select
                formControlName="employeeId"
                [data]="employees$ | async"
                placeholder="{{
                  'statistic.operation.search.employee' | translate
                }}"
                valueMember="id"
                displayMember="fullName"
              ></beautyapp-select>
            </div>
            <div
              nz-col
              [nzXl]="4"
              [nzLg]="6"
              [nzMd]="8"
              [nzSm]="12"
              [nzXs]="24"
            >
              <beautyapp-select-search
                formControlName="userId"
                [data]="customers$ | async"
                placeholder="{{
                  'statistic.operation.search.user' | translate
                }}"
                (onSearch)="searchCustomer($event)"
                valueMember="id"
                displayMember="fullName"
              ></beautyapp-select-search>
            </div>
          </div>

          <!-- Toggles on the left, actions pushed to the right. -->
          <div class="flex flex-wrap items-center gap-x-6 gap-y-2 mt-3">
            <label nz-checkbox formControlName="isDeleted">{{
              'statistic.transaction.search.deleted' | translate
            }}</label>
            <label nz-checkbox formControlName="isVatIncluded">
              დღგ-ით დასაბეგრი
            </label>

            <div class="ml-auto search-area">
              <nz-space>
                <button
                  *nzSpaceItem
                  nz-button
                  nzType="primary"
                  nzShape="circle"
                  (click)="search()"
                >
                  <i nz-icon nzType="search"></i>
                </button>
                <button
                  *nzSpaceItem
                  nz-button
                  nzShape="circle"
                  (click)="clearSearch()"
                >
                  <i nz-icon nzType="close"></i>
                </button>

                <ng-template [ngxPermissionsOnly]="['Admin', 'Manager']">
                  <button
                    *nzSpaceItem
                    nz-button
                    nzType="default"
                    nzShape="circle"
                    nz-tooltip
                    [nzTooltipTitle]="'buttons.download' | translate"
                    (click)="export()"
                  >
                    <i nz-icon nzType="file-excel" nzTheme="outline"></i>
                  </button>
                </ng-template>
              </nz-space>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div nz-col class="body-content">
      <!--      <pre>-->
      <!--      {{employees | json}}-->
      <!--      </pre>-->
      <nz-table
        nzShowSizeChanger
        [nzData]="loadData"
        [nzFrontPagination]="false"
        [nzLoading]="loading"
        [nzTotal]="total"
        [nzPageSize]="paginatorPageSize"
        [nzPageIndex]="paginatorPageIndex"
        [nzVirtualForTrackBy]="trackByIndex"
        (nzQueryParams)="paginatorChange($event)"
        [nzPageSizeOptions]="[5, 10, 20, 50, 100]"
        nzTableLayout="auto"
        [nzScroll]="{ x: '84vw' }"
        nzSize="small"
      >
        <thead>
          <tr>
            <th nzWidth="80px">
              {{ 'statistic.operation.column.operationNumber' | translate }}
            </th>
            <th nzWidth="220px">
              {{ 'statistic.operation.column.sourceOperation' | translate }}
            </th>
            <th nzWidth="200px">
              {{ 'statistic.operation.column.paymentMethod' | translate }}
            </th>
            <th nzWidth="100px">
              {{ 'statistic.operation.column.date' | translate }}
            </th>
            <th nzWidth="110px">
              {{ 'statistic.operation.column.price' | translate }}
            </th>
            <th nzWidth="80px">
              {{ 'statistic.operation.column.cash' | translate }}
            </th>
            <th nzWidth="80px">
              {{ 'statistic.operation.column.card' | translate }}
            </th>
            <th nzWidth="80px">
              {{ 'statistic.operation.column.bank' | translate }}
            </th>
            <th nzWidth="120px">
              {{ 'statistic.operation.column.bankName' | translate }}
            </th>
            <th nzWidth="100px">
              {{ 'statistic.operation.column.balance' | translate }}
            </th>
            <th nzWidth="130px">
              {{ 'statistic.operation.column.minutes' | translate }}
            </th>
            <th nzWidth="130px">
              {{ 'statistic.operation.column.barter' | translate }}
            </th>
            <th nzWidth="220px">
              {{ 'statistic.operation.column.user' | translate }}
            </th>
            <th nzWidth="220px">
              {{ 'statistic.operation.column.employee' | translate }}
            </th>
            <th nzWidth="200px">
              {{ 'statistic.operation.column.createdBy' | translate }}
            </th>
            <th nzWidth="300px">
              {{ 'statistic.operation.column.procedure' | translate }}
            </th>
            <th nzWidth="150px">
              {{ 'statistic.operation.column.created' | translate }}
            </th>
            <th nzWidth="80px" nzRight></th>
          </tr>
        </thead>
        <tbody>
          @for (row of loadData; track row; let i = $index) {
          <tr>
            <td>{{ row?.id }}</td>
            <td>
              @if (row?.operationSource === 'SERVICE_PACKAGE' &&
              row?.servicePackagePurchaseId) {
              <ng-container
                *ngxPermissionsOnly="
                  ['Admin', 'Administrator', 'Manager'];
                  else plainSource
                "
              >
                <nz-tag
                  (click)="viewPackagePurchase(row)"
                  style="cursor: pointer"
                >
                  {{ 'OPERATION_SOURCE.' + row?.operationSource | translate }}
                  <span nz-icon nzType="link" nzTheme="outline"></span>
                </nz-tag>
              </ng-container>
              <ng-template #plainSource>
                {{ 'OPERATION_SOURCE.' + row?.operationSource | translate }}
              </ng-template>
              } @else {
              {{ 'OPERATION_SOURCE.' + row?.operationSource | translate }}
              } @if (row?.isGift) {
              <i nz-icon nzType="gift" nzTheme="outline"></i>
              } @if (editingCommentId === row.id) {
              <div
                class="flex items-center gap-1 mt-1"
                style="min-width: 220px"
              >
                <textarea
                  nz-input
                  [(ngModel)]="editingCommentValue"
                  [nzAutosize]="{ minRows: 1, maxRows: 4 }"
                  style="width: 200px"
                  [attr.aria-label]="'operation.editComment' | translate"
                ></textarea>
                <button
                  nz-button
                  nzType="primary"
                  nzSize="small"
                  nzShape="circle"
                  [nzLoading]="savingComment"
                  [disabled]="
                    savingComment ||
                    !editingCommentValue?.trim() ||
                    editingCommentValue === row.description
                  "
                  [attr.aria-label]="'buttons.save' | translate"
                  (click)="saveEditComment(row)"
                >
                  <i nz-icon nzType="check"></i>
                </button>
                <button
                  nz-button
                  nzSize="small"
                  nzShape="circle"
                  [disabled]="savingComment"
                  [attr.aria-label]="'buttons.cancel' | translate"
                  (click)="cancelEditComment()"
                >
                  <i nz-icon nzType="close"></i>
                </button>
              </div>
              } @else { @if (row?.description) {
              <i
                nz-icon
                nzType="comment"
                nzTheme="outline"
                [nz-tooltip]="row?.description"
              ></i>
              } @if (row?.operationSource === 'BALANCE') { @if
              (canEditComment(row)) {
              <button
                nz-button
                nzType="text"
                nzSize="small"
                nzShape="circle"
                class="ml-1"
                [nz-tooltip]="'operation.editComment' | translate"
                [attr.aria-label]="'operation.editComment' | translate"
                (click)="startEditComment(row)"
              >
                <i nz-icon nzType="edit" nzTheme="outline"></i>
              </button>
              }
              <button
                nz-button
                nzType="text"
                nzSize="small"
                nzShape="circle"
                class="ml-1"
                nz-popover
                nzPopoverTrigger="click"
                [nzPopoverTitle]="'operation.commentHistory' | translate"
                [nzPopoverContent]="commentHistoryTmpl"
                (nzPopoverVisibleChange)="onHistoryVisibleChange(row, $event)"
                [nz-tooltip]="'operation.commentHistory' | translate"
                [attr.aria-label]="'operation.commentHistory' | translate"
              >
                <i nz-icon nzType="history" nzTheme="outline"></i>
              </button>
              <ng-template #commentHistoryTmpl>
                <div
                  style="max-width: 320px; max-height: 260px; overflow-y: auto"
                >
                  @if (historyLoading) {
                  <div>...</div>
                  } @else if (!historyRows.length) {
                  <div>{{ 'operation.noCommentEdits' | translate }}</div>
                  } @else { @for (h of historyRows; track h.id) {
                  <div
                    class="mb-2 pb-2"
                    style="border-bottom: 1px solid #f0f0f0"
                  >
                    <div style="font-size: 12px; color: #999">
                      {{ h.changedAt | date : 'dd/MM/yyyy HH:mm' }}
                      —
                      {{
                        'operation.editedBy'
                          | translate
                            : { name: resolveChangerName(row, h.changedById) }
                      }}
                    </div>
                    <div>
                      <del>{{ h.oldComment || '—' }}</del>
                      →
                      {{ h.newComment || '—' }}
                    </div>
                  </div>
                  } }
                </div>
              </ng-template>
              <i
                nz-icon
                role="button"
                tabindex="0"
                [nzType]="expandSet.has(row.id) ? 'up-circle' : 'down-circle'"
                nzTheme="outline"
                class="ml-1"
                style="cursor: pointer"
                [nz-tooltip]="'operation.detailsByBank' | translate"
                [attr.aria-label]="'operation.detailsByBank' | translate"
                (click)="onExpandChange(row.id, !expandSet.has(row.id))"
                (keydown.enter)="onExpandChange(row.id, !expandSet.has(row.id))"
              ></i>
              } }
            </td>
            <td>
              {{ row?.paymentType | paymentType | translate }}
            </td>
            <td>{{ row?.operationDate | date : 'dd/MM/yyyy' }}</td>
            <td>
              @if (row?.salePrice > 0) {
              <div class="flex items-center gap-1">
                {{ row?.salePrice }}
                <del>{{ row?.price }} </del>
              </div>
              } @if (row?.salePrice <= 0) {
              <div>
                {{ row?.price }}
              </div>
              }
            </td>
            <td>{{ +row?.cash }}</td>
            <td>{{ +row.card }}</td>
            <td>{{ +row.bank }}</td>
            <td>{{ row?.bankNames || '—' }}</td>
            <td>{{ +row.balance }}</td>
            <td>{{ +row.minutes }}</td>
            <td>{{ +row.barter }}</td>
            <td>
              @if (row?.user) {
              <nz-tag (click)="viewUser(row?.user)" style="cursor: pointer">
                {{ row.user.fullName }}
                <span nz-icon nzType="link" nzTheme="outline"></span>
              </nz-tag>
              }
            </td>
            <td>{{ row?.employee ? row?.employee?.user?.fullName : '' }}</td>
            <td>{{ row?.createdBy?.fullName || '—' }}</td>
            <td>
              @let service = row?.operationDetails &&
              row?.operationDetails?.length ?
              row?.operationDetails[0]?.service?.name : 'N/A'; @let services =
              row.operationDetails && row.operationDetails.length ?
              row.operationDetails : []; @if (services.length === 1) {
              <nz-tag [nz-tooltip]="service">
                {{ service | slice : 0 : 20 }}
              </nz-tag>
              } @else if (services.length > 1) {
              <nz-tag
                [nz-tooltip]="service"
                [nzColor]="services[0]?.serviceCategory?.color"
              >
                {{ service | slice : 0 : 20 }}
              </nz-tag>
              @if (services.length > 1) {
              <nz-tag>+{{ services.length - 1 }}</nz-tag>
              } } @else {
              <span>N/A</span>
              }
            </td>
            <td>{{ row?.createdAt | date : 'dd/MM/yyyy HH:mm' }}</td>
            <td nzRight>
              <nz-space>
                <button
                  *nzSpaceItem
                  (click)="view(row)"
                  nz-button
                  nzType="primary"
                  nzSize="small"
                  nzShape="circle"
                >
                  <i nz-icon nzType="eye"></i>
                </button>
                @if (!row.deletedAt) { @if (canDelete(row)) {
                <button
                  *nzSpaceItem
                  (click)="delete(row)"
                  nz-button
                  nzDanger
                  nzSize="small"
                  nzShape="circle"
                  [disabled]="row.operationSource === 'BALANCE'"
                >
                  <i nz-icon nzType="delete"></i>
                </button>
                } } @else {
                <ng-template [ngxPermissionsOnly]="['Admin', 'Manager']">
                  <button
                    *nzSpaceItem
                    nz-button
                    nzType="default"
                    nzSize="small"
                    nzShape="circle"
                    nz-popover
                    nzPopoverTitle="წაშლილია"
                    [nzPopoverContent]="deleteReason"
                  >
                    <span nz-icon nzType="info" nzTheme="outline"></span>
                  </button>
                  <ng-template #deleteReason>
                    <div nz-row>
                      <div nz-col nzSpan="24">
                        წაიშალა:
                        {{ row?.deletedAt | date : 'dd/MM/yyyy HH:mm' }}
                      </div>
                      <div nz-col nzSpan="24">
                        წაშალა: {{ row?.deletedBy?.fullName }}
                      </div>
                      @if (row?.deletedReason) {
                      <div nz-col nzSpan="24">
                        <nz-alert
                          nzType="error"
                          nzMessage="წაშლის მიზეზი"
                          [nzDescription]="deleteDescTmpl"
                        ></nz-alert>
                        <ng-template #deleteDescTmpl>
                          <div
                            nz-col
                            nzSpan="24"
                            [innerText]="row?.deletedReason"
                          ></div>
                        </ng-template>
                      </div>
                      }
                    </div>
                  </ng-template>
                </ng-template>
                }
              </nz-space>
            </td>
          </tr>
          @if (row?.operationSource === 'BALANCE' && expandSet.has(row.id)) {
          <tr>
            <td [attr.colspan]="18" style="background: #fafafa">
              <div class="p-2">
                <div class="font-medium mb-1">
                  {{ 'operation.detailsByBank' | translate }}
                </div>
                @if (row?.banks?.length) {
                <div class="flex flex-wrap gap-x-6 gap-y-1 text-sm">
                  <span>
                    {{ 'statistic.operation.column.bankName' | translate }}:
                    {{ row.bankNames }}
                  </span>
                  @if (+row.cash > 0) {
                  <span>
                    {{ 'statistic.operation.column.cash' | translate }}:
                    {{ +row.cash }}
                  </span>
                  } @if (+row.card > 0) {
                  <span>
                    {{ 'statistic.operation.column.card' | translate }}:
                    {{ +row.card }}
                  </span>
                  } @if (+row.bank > 0) {
                  <span>
                    {{ 'statistic.operation.column.bank' | translate }}:
                    {{ +row.bank }}
                  </span>
                  }
                </div>
                } @else {
                <span class="text-gray-500">
                  {{ 'operation.noBankInfo' | translate }}
                </span>
                }
              </div>
            </td>
          </tr>
          } }
        </tbody>
        <tfoot>
          <tr style="font-weight: bold; background: #fafafa">
            <td [attr.colspan]="4" style="text-align: right">ჯამი:</td>
            <td>{{ totals.totalPrice | number : '1.0-2' }}</td>
            <td>{{ totals.totalCash | number : '1.0-2' }}</td>
            <td>{{ totals.totalCard | number : '1.0-2' }}</td>
            <td>{{ totals.totalBank | number : '1.0-2' }}</td>
            <td></td>
            <td>{{ totals.totalBalance | number : '1.0-2' }}</td>
            <td [attr.colspan]="2"></td>
            <td [attr.colspan]="6" style="text-align: left">
              @if (totals.totalVat) { დღგ:
              {{ totals.totalVat | number : '1.0-2' }}
              }
            </td>
          </tr>
        </tfoot>
      </nz-table>
    </div>
  </div>
</div>
